import {Injectable} from '@angular/core';
import {Question} from 'app/models/question.model';
import {Answer} from 'app/models/answer.model';
import {StandardQuestionDraft, standardQuestionsFromDraft} from 'app/services/standard-question-draft';

const EMPTY_QUESTION_TEXT = '';
const FIRST_ANSWER_GROUP = 0;
const ANSWER_NUMBER_OFFSET = 1;
const ANSWER_COUNT = 3;
const QUESTION_NOT_FOUND = -1;
const FIRST_QUESTION_INDEX = 0;
const SINGLE_QUESTION = 1;
const RUSSIAN_LANGUAGE = 'Ru';
const ENGLISH_LANGUAGE = 'En';
const ANSWER_FIELDS = ['answerOne', 'answerTwo', 'answerThree'];
const QUESTION_FIELDS = { right: 'rightAnswer', text: 'questionText' };

interface StoredQuestion {
  questionText: string;
  answers: Answer[];
  rightAnswer: Answer;
  isTesting?: boolean;
}

@Injectable()
export class StepTestingService {
  russianQuestions: Question[] = [];
  englishQuestions: Question[] = [];
  public questionList: StandardQuestionDraft[] = [];
  public qAddedingProcess = false;

  deleteQuestionFromList(index): void {
    if (index > QUESTION_NOT_FOUND) { this.questionList.splice(index, SINGLE_QUESTION); }
  }

  addQuestionToList(): void {
    this.questionList.push(this.emptyQuestion());
  }

  private emptyQuestion(): StandardQuestionDraft {
    return {
      questionTextRu: EMPTY_QUESTION_TEXT, questionTextEn: EMPTY_QUESTION_TEXT,
      rightAnswerRu: EMPTY_QUESTION_TEXT, rightAnswerEn: EMPTY_QUESTION_TEXT,
      answers: [{
        answerOneRu: EMPTY_QUESTION_TEXT, answerTwoRu: EMPTY_QUESTION_TEXT, answerThreeRu: EMPTY_QUESTION_TEXT,
        answerOneEn: EMPTY_QUESTION_TEXT, answerTwoEn: EMPTY_QUESTION_TEXT, answerThreeEn: EMPTY_QUESTION_TEXT
      }]
    };
  }

  getQuestionList(): StandardQuestionDraft[] {
    return this.questionList;
  }

  isQuestionsValid(language: string): boolean {
    if (language !== RUSSIAN_LANGUAGE && language !== ENGLISH_LANGUAGE) { return true; }
    return this.questionList.every(question => this.isQuestionValid(question, language));
  }

  private isQuestionValid(question: StandardQuestionDraft, language: string): boolean {
    const rightAnswer = Number(question[QUESTION_FIELDS.right + language]);
    return !!question[QUESTION_FIELDS.text + language] && rightAnswer >= ANSWER_NUMBER_OFFSET
      && rightAnswer <= ANSWER_COUNT && Number.isInteger(rightAnswer)
      && question.answers.every(answers => ANSWER_FIELDS.every(field => !!answers[field + language]));
  }

  addQuestionToStandardTemp(): StandardQuestionDraft[] {
    return this.questionList;
  }

  addQuestionsToStandard() {
    this.qAddedingProcess = true;
    const questions = standardQuestionsFromDraft(this.questionList);
    this.russianQuestions = questions.russian;
    this.englishQuestions = questions.english;
    return questions;
  }

  addQuestionToListCopy(index): void {
    this.questionList.push(JSON.parse(JSON.stringify(this.questionList[index])));
  }

  addExistingQuestuins(englishQuestions: StoredQuestion[], russianQuestions: StoredQuestion[]): void {
    const english = englishQuestions || [];
    const russian = russianQuestions || [];
    const count = Math.max(english.length, russian.length);
    for (let index = FIRST_QUESTION_INDEX; index < count; index++) {
      const draft = this.emptyQuestion();
      this.fillQuestion(draft, russian[index], RUSSIAN_LANGUAGE);
      this.fillQuestion(draft, english[index], ENGLISH_LANGUAGE);
      this.questionList.push(draft);
    }
  }

  private fillQuestion(draft: StandardQuestionDraft, question: StoredQuestion, language: string): void {
    if (!question) { return; }
    draft[QUESTION_FIELDS.text + language] = question.questionText;
    draft.checked = question.isTesting;
    const index = question.answers.findIndex(answer => question.rightAnswer && answer.answerText === question.rightAnswer.answerText);
    draft[QUESTION_FIELDS.right + language] = String(index + ANSWER_NUMBER_OFFSET);
    ANSWER_FIELDS.forEach((field, answerIndex) => {
      const answer = question.answers[answerIndex];
      draft.answers[FIRST_ANSWER_GROUP][field + language] = answer ? answer.answerText : EMPTY_QUESTION_TEXT;
    });
  }

  clearQuestions(): void {
    this.questionList = [];
    this.russianQuestions = [];
    this.englishQuestions = [];
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-six/step-create-testing/step-testing.service.ts